import axios from "axios";
import firebase from "firebase";
import firestore from "../firebase/firestore";
import api from "../utils/api";

export const emptyBilling = async (competence, consumer_unit_id) => {
  const config = {
    data: {
      competence: competence,
      consumer_unit: consumer_unit_id,
    },
    url: process.env.VUE_APP_EMPTYBILLING,
    method: "post",
  };
  let res = await axios(config);
  return res.data;
};

export const rebilling = async (
  billing_ids,
  payment_method,
  due_date,
  retira_multa,
  retira_juros,
) =>
  await api.post(process.env.VUE_APP_REBILLING, {
    billing_ids: billing_ids,
    payment_method,
    due_date,
    retira_multa,
    retira_juros,
  });

export const getFine = async (consumer_unit_id, customer_id) => {
  const config = {
    data: {
      consumer_unit: consumer_unit_id,
      customer_id: customer_id,
    },
    url: process.env.VUE_APP_GETFINE,
    method: "post",
  };
  let res = await axios(config);
  return res.data;
};

export const simulateAllParcel = async (
  billing_ids,
  charge_type,
  retira_multa,
  retira_juros,
) =>
  await api.post(process.env.VUE_APP_INSTALLMENTS, {
    billing_ids: billing_ids,
    charge_type: charge_type,
    retira_multa: retira_multa,
    retira_juros: retira_juros,
  });

export const simulateReparcel = async (debt_billing_id, new_due_date) =>
  await api.post(process.env.VUE_APP_SIMULATE_REPARCEL, {
    debt_billing_id: debt_billing_id,
    new_due_date: new_due_date,
  });

export const parcel = async (
  billing_ids,
  num_installments,
  charge_type,
  unique_due_date,
  rebillingPenalty,
  rebillingInterest,
  agent_id,
  ip_info,
  utm,
  selected_credit_card,
) =>
  await api.post(process.env.VUE_APP_PARCELBILLING, {
    billing_ids: billing_ids,
    num_installments: num_installments,
    charge_type: charge_type,
    agent_id: agent_id,
    retira_multa: rebillingPenalty,
    retira_juros: rebillingInterest,
    unique_due_date,
    ip_info,
    utm,
    card_hash: selected_credit_card,
  });

export const reparcel = async (debt_billing_id, due_date, agent_id, ip_info) =>
  await api.post(process.env.VUE_APP_REPARCEL, {
    debt_billing_id,
    due_date,
    agent_id,
    ip_info,
  });

export const reparcelAll = async (
  installment_group_id,
  due_date,
  agent_id,
  ip_info,
) =>
  await api.post(process.env.VUE_APP_REPARCEL_ALL, {
    installment_group_id,
    first_due_date: due_date,
    agent_id,
    ip_info,
  });

export const changeDueDate = async (billing_id, due_date) =>
  await api.post(process.env.VUE_APP_CHANGEDUEDATE, { billing_id, due_date });

export const cancel = async (installment_group_id, persist) =>
  await api.post(process.env.VUE_APP_CANCELDEAL, {
    installment_group_id,
    persist,
  });

export const getTotalBilling = async (power_plant_id, competence) => {
  return await firestore
    .doc(`TotalBilling/${power_plant_id}-${competence}`)
    .get();
};

export const setBilling = (data) => {
  const invoice = JSON.parse(JSON.stringify(data));
  invoice.created_at = new Date();
  invoice.updated_at = new Date();

  const docRef = firestore.collection("billing");
  return docRef
    .add(invoice)
    .then(() => {
      return docRef.get();
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const getBilling = (id) => {
  return firestore.collection("billing").doc(id);
};

export const getBillings = (consumer_unit) => {
  return firestore
    .collection("billing")
    .where("consumer_unit", "==", consumer_unit);
};

export const getBillingsByUser = (customer_id) => {
  return firestore
    .collection("billing")
    .where("customer_id", "==", customer_id);
};

export const getBillingsByUserOpened = async (customer_id) => {
  let billings = await firestore
    .collection("billing")
    .where("customer_id", "==", customer_id)
    .where("status", "not-in", [
      "paid",
      "free",
      "refunded",
      "waiting_payment",
      "in_queue",
      "pending_approval",
    ])
    .get();

  if (billings.size <= 0) return null;
  else {
    return billings;
  }
};

export const updateBilling = async (id, data) => {
  return await firestore.doc(`billing/${id}`).update(data);
};

export const createTotalBilling = async (power_plant, competence, data) => {
  const totalBillingId = power_plant + "-" + competence;
  const totalBillingRef = firestore
    .collection("TotalBilling")
    .doc(totalBillingId);
  const totalBillingCompetence = await totalBillingRef.get();
  if (totalBillingCompetence.exists) {
    throw "Essa competência já existe.";
  } else {
    return firestore.collection("TotalBilling").doc(totalBillingId).set(data);
  }
};

export const getBillingDebug = (id) => {
  return firestore.collection("billing_debug").doc(id).get();
};

export const updateUtilityFares = async (data) => {
  try {
    return await firestore
      .collection("config")
      .doc("utility_fare_values")
      .update(data);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getDebtBillingById = async (id) => {
  try {
    return await firestore.collection("debt_billing").doc(id).get();
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const billBySpreadsheet = (
  consumer_unit,
  power_plant_id,
  competence,
  report_date,
  utility_company,
  billing_data,
) =>
  api.post(process.env.VUE_APP_BILLBYSPREADSHEET, {
    consumer_unit,
    power_plant_id,
    competence,
    report_date,
    utility_company,
    billing_data,
  });

export const billByXML = (
  consumer_unit,
  power_plant_id,
  competence,
  report_date,
) =>
  api.post(process.env.VUE_APP_BILLBYXML, {
    consumer_unit,
    power_plant_id,
    competence,
    report_date,
    simulate: false,
  });

export const removeTransaction = async (id) => {
  const billingRef = firestore.collection("billing");
  try {
    return await billingRef.doc(id).update({
      transaction: firebase.firestore.FieldValue.delete(),
    });
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const createCancelBilling = async (data) => {
  return await api.post(process.env.VUE_APP_CREATECANCELBILLING, data);
};

export const uploadNewGDReport = async (data) => {
  return await api.post(process.env.VUE_APP_UPLOAD_NEW_GD_REPORT_URL, data);
};

export const sendInvoice = async (data, token) => {
  return await api.post(
    process.env.VUE_APP_SEND_INVOICE,
    { billing_id: data },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const updateSpecialBilling = async (id, data) => {
  return await firestore.doc(`debt_billing/${id}`).update(data);
};

export const joinedBilling = async (
  simulate,
  customer_id,
  force_unification,
  due_date,
  billing_ids,
) => {
  return await api.post(process.env.VUE_APP_JOINEDBILLING, {
    simulate,
    customer_id,
    force_unification,
    due_date,
    billing_ids,
  });
};

export const recalcInvoice = async (billing_data) =>
  await api.put(process.env.VUE_APP_RECALC_INVOICE, billing_data);

export const createTotalBillingWithFare = async (fare_data) => {
  return await api.post(process.env.VUE_APP_GD_OPERATIONS, {
    operation: "inicio_faturamento",
    fare_data,
  });
};

export const uploadNewNeoenergiaReport = async (data) => {
  return await api.post(process.env.VUE_APP_UPLOAD_REPORT_NEOENERGIA, data, {
    timeout: 60000,
  });
};
